import { render, staticRenderFns } from "./UserDeleteModal.vue?vue&type=template&id=fa08c85e&scoped=true"
import script from "./UserDeleteModal.vue?vue&type=script&lang=js"
export * from "./UserDeleteModal.vue?vue&type=script&lang=js"
import style0 from "@/components/modal/BasicModal.scss?vue&type=style&index=0&id=fa08c85e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa08c85e",
  null
  
)

export default component.exports